export interface CustomerInfoFields {
    name: string;
    surname: string;
    email: string;
    phone: string;
    postcode: string;
    gettoknow: string;
    additionalInfo: string;
}

export function isPersonalDataFormValid(
    customerInfo: CustomerInfoFields,
    termsAccepted: boolean
): boolean {
    const requiredFields: Array<keyof Pick<CustomerInfoFields, 'name' | 'surname' | 'email' | 'phone' | 'postcode' | 'gettoknow'>> = [
        'name',
        'surname',
        'email',
        'phone',
        'postcode',
        'gettoknow',
    ];

    for (const field of requiredFields) {
        if (!customerInfo[field].trim()) {
            return false;
        }
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(customerInfo.email.trim())) {
        return false;
    }

    return termsAccepted;
}
